//bao migrate skip

import "./../../bindings/bao-searcher";
import "./../../bindings/bao-number-box";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";
class SubProjectDialog implements ISubProjectDialog {
    Dialog: BaoDialog = new BaoDialog(Bao.Session.ApplicationName);
    DialogResult: KnockoutObservable<boolean> = this.Dialog.DialogResult;
    SessionTabId: string;
    ProjectId: string;
    SubProjectId: string;
    IndicatorId: string;
    constructor(sessionTabId: string, projectId: string, subProjectId: string, indicator: string) {
        this.Dialog.Width("600px");
        this.Dialog.Buttons([
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgOk"), $.proxy(this.OkClick, this)),
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgCancel"), $.proxy(this.CancelClick, this))
        ]);
        this.SessionTabId = sessionTabId;
        this.ProjectId = projectId;
        this.SubProjectId = subProjectId;
        this.IndicatorId = indicator;
    }
    Open() {
        var self = this;
        self.Dialog.IsLoading(true);
        Bao.post("ConfigurationItemTab/ShowConfigurationItemSubprojectDialog", JSON.stringify({
            sessionTabId: self.SessionTabId,
            parentConfigurationItemId: self.ProjectId,
            configurationItemId: self.SubProjectId,
            indicatorId: self.IndicatorId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().Focus = function () { };
            self.Dialog.Template(value.Message);
            self.Dialog.IsLoading(false);
            self.Dialog.Open(null);
            self.Dialog.ViewModel().Focus();
        });
    }
    OkClick(): void {
        if (this.CompleteCheck() == true) {
            this.AddSubProject(this.Dialog.ViewModel()).then(() => {
                this.DialogResult(true);
                this.Dialog.Close();
            });
        }
    }
    AddSubProject(model: ISubProjectModel): JQueryPromise<void> {
        var self = this;
        this.Dialog.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemSubproject", JSON.stringify({
            sessionTabId: self.SessionTabId,
            parentConfigurationItemId: self.ProjectId,
            subProjectModel: ko.map.toJS(model)
        }));
    }
    ;
    CancelClick(): void {
        this.DialogResult(false);
        this.Dialog.Close();
    }
    CompleteCheck(): boolean {
        var isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.Dialog.ViewModel().Number())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.Dialog.ViewModel().Name1())) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
}
export default SubProjectDialog;

export interface ISubProjectDialogStatic {
    new (sessionTabId: string, projectId: string, subProjectId: string, indicatorId: string): ISubProjectDialog;
}

export interface ISubProjectDialog {
    Dialog: BaoDialog;
    DialogResult: KnockoutObservable<boolean>;

    SessionTabId: string;
    ProjectId: string;
    SubProjectId: string;
    IndicatorId: string;
    
    Open: () => void;
    OkClick: () => void;
    CancelClick: () => void;
}

export interface ISubProjectModel {
    ConfigurationItemId: KnockoutObservable<string>;
    QualificationModelsFiltered: KnockoutObservableArray<any>;
}